/**
 * Google Analytics Utility Functions
 * GA4 Measurement ID: G-CWZJE4GHWJ
 * 
 * IMPORTANT: GA script is loaded dynamically only after user opt-in.
 * All functions check for gtag existence before calling.
 */

// Safe gtag wrapper - only calls gtag if it exists
const safeGtag = (...args) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
    return true;
  }
  return false;
};

// Track page views
export const trackPageView = (url, title) => {
  safeGtag('config', 'G-CWZJE4GHWJ', {
    page_path: url,
    page_title: title
  });
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  safeGtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};

// Track donation events
export const trackDonation = (campaignId, amount, currency = 'USD') => {
  safeGtag('event', 'purchase', {
    transaction_id: `donation_${Date.now()}`,
    value: amount,
    currency: currency,
    items: [{
      item_id: campaignId,
      item_name: 'Donation',
      item_category: 'Campaign Donation',
      price: amount,
      quantity: 1
    }]
  });
};

// Track campaign creation
export const trackCampaignCreation = (campaignId, category) => {
  safeGtag('event', 'campaign_created', {
    event_category: 'Campaign',
    event_label: category,
    campaign_id: campaignId
  });
};

// Track user signup
export const trackSignup = (method) => {
  safeGtag('event', 'sign_up', {
    method: method
  });
};

// Track user login
export const trackLogin = (method) => {
  safeGtag('event', 'login', {
    method: method
  });
};

// Track campaign share
export const trackShare = (campaignId, platform) => {
  safeGtag('event', 'share', {
    method: platform,
    content_type: 'campaign',
    item_id: campaignId
  });
};

// Track search
export const trackSearch = (searchTerm) => {
  safeGtag('event', 'search', {
    search_term: searchTerm
  });
};

export default {
  trackPageView,
  trackEvent,
  trackDonation,
  trackCampaignCreation,
  trackSignup,
  trackLogin,
  trackShare,
  trackSearch
};
